var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "textarea can-go-dark winner-textbox",
    attrs: { id: "winners", spellcheck: "false" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }